import { Component, OnInit, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AddCommentComponent } from '../add-comment/add-comment.component';
import { Months } from 'src/app/enums/months.enum';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-comments',
  templateUrl: './comments.component.html',
  styleUrls: ['./comments.component.scss']
})
export class CommentsComponent implements OnInit {
  @Input() comments : any[] = [];
  @Input() user : any;

  constructor(
    private dialog: MatDialog,
    private datepipe: DatePipe
  ) { }

  ngOnInit() {
    
  }

  addComment(){
    let dialogRef = this.dialog.open(AddCommentComponent,{
      width: '776px',
      disableClose: true,
      data: this.user.id
    });

    dialogRef.afterClosed().subscribe(
      (response)=>{
        if (response) {
          this.comments.push(response)
        }
      }
    );
  }

  getDateFormated(date:string){
    let day = (new Date(date)).getDate();
    //@ts-ignore
    let month = Months.find((element)=> element.value == (new Date(date)).getMonth()).nameLarge;
    let year = (new Date(date)).getFullYear();
    let hour = this.datepipe.transform(new Date(date),'HH:mm');
    
    return `${day} de ${month}, ${year}, ${hour} Hrs`
  }

}
